import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  chamar(event) {
    const btn = event.currentTarget
    const atendimentoId = btn.dataset.atendimentoId
    const atendente = btn.dataset.atendente

    document.getElementById("q_atendimento_id").value = atendimentoId

    if (atendente) {
      const select = document.getElementById("q_atendente")
      const option = Array.from(select.options).find(o => o.value === atendente)
      if (option) select.value = atendente
    }

    document.getElementById("atendimentos_form").requestSubmit()
  }
}
